<script setup lang="ts" generic="V extends string | number">
import { PV } from "@/widgets";
import { RouterLink } from "vue-router";
import { privileges, type Privilege } from "../../common/privilege.common";
import type { Tab } from "../../data/tabs";

const props = defineProps<{
    current: NoInfer<V>;
    tabs: readonly Tab[];
}>();

function isVisible(privilege: Privilege.Names | Privilege.Names[] | undefined) {
    if (privilege === undefined) return true;

    let tabPrivileges: Privilege.Names[];
    if (Array.isArray(privilege)) {
        tabPrivileges = privilege;
    } else {
        tabPrivileges = [privilege];
    }

    return privileges.includes(tabPrivileges);
}
</script>

<template>
    <PV.Tabs :value="props.current">
        <PV.TabList class="overflow-x-auto pb-1.5">
            <template v-for="tab in props.tabs" :key="tab.route">
                <PV.Tab v-if="isVisible(tab.privilege)" asChild :value="tab.value">
                    <RouterLink v-if="tab.value !== props.current" class="rns-tab" :to="tab.route">
                        <component :is="tab.icon" />
                        <span>{{ tab.title }}</span>
                    </RouterLink>
                    <a v-else class="rns-tab rns-tab-active" :href="tab.route">
                        <component :is="tab.icon" />
                        <span>{{ tab.title }}</span>
                    </a>
                </PV.Tab>
            </template>
        </PV.TabList>
    </PV.Tabs>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-tab {
    @apply text-gray-500 flex items-center gap-2 px-4 py-3 font-semibold;
}

.rns-tab-active {
    @apply border-b-2 border-b-sky-500 text-sky-500;
}
</style>
